import React, { useState } from 'react';
import SliderInput from './Slider';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../../../Actions/FacetedSearch.action';

const FilterSlider = ({ group }) => {
  if (!group) return null;

  const currencyId = group.currencyId;
  const dispatch = useDispatch();

  const firstItem = group.options[0];
  const lastItem = group.options[group.options.length - 1];
  const lowest = parseInt(firstItem.id.substr(0, firstItem.id.indexOf('-')));
  const heighest = parseInt(lastItem.id.substr(lastItem.id.indexOf('-') + 1));

  let initLowest = lowest;
  let initHeighest = heighest;

  if (group.selectedOptions.length > 0) {
    initLowest = group.selectedOptions.map(i => parseInt(i.substr(0, i.indexOf('-')))).sort((a, b) => a - b)[0];
    initHeighest = group.selectedOptions.map(i => parseInt(i.substr(i.indexOf('-') + 1))).sort((a, b) => b - a)[0];
  }

  const [fromValues, setFromValues] = useState({
    value: initLowest,
    min: lowest,
    max: heighest - 1,
    limit: heighest,
  });
  const [toValues, setToValues] = useState({
    value: initHeighest,
    min: lowest + 1,
    max: heighest,
    limit: lowest,
  });

  const handleFromChange = (e, isMouseDown) => {
    const value = +e.target.value;
    setFromValues({ ...fromValues, value });
    setToValues({ ...toValues, limit: value });
  };

  const handleToChange = (e, isMouseDown) => {
    const value = +e.target.value;
    if (value <= fromValues.value) return;
    setToValues({ ...toValues, value });
    setFromValues({ ...fromValues, limit: value });
  };

  const handleRelease = () => applyRange();

  const applyRange = () => {
    dispatch(
      searchFacetChange(group, { label: '', quantity: 1, id: `${fromValues.value}-${toValues.value}` })
    );
  };

  return (
    <div className="filter-slider">
      <div className="filter-slider__labels">
        <label htmlFor="to">{fromValues.value} {currencyId}</label>
        <label htmlFor="from">{toValues.value} {currencyId}</label>
      </div>
      <div className="filter-slider__sliders-control">
        <SliderInput
          name={'from'}
          sliderValues={fromValues}
          onChange={handleFromChange}
          onRelease={handleRelease}
        />
        <SliderInput
          name={'to'}
          sliderValues={toValues}
          onChange={handleToChange}
          onRelease={handleRelease}
        />
      </div>
    </div>
  );
};
export default FilterSlider;
